export default "__VITE_ASSET__c8379642__"